
/**
 * @fileOverview ContentSliderView View Module File
 *
 *  This module handles the laying out of a list of content items.  It allows a number of content elements to be visible at once.
 *  it also allows the visible content items to be filtered down base on a parameter.
 *
 *  This module also provides an interface with which it can be updated by outside controllers, both in its position
 *  and its visible content filter can be updated.
 *
 * NOTE: THIS REQUIRE MODULE IS NAME SPACED, AND NEEDS TO HAVE ITS WRAPPER FUNCTION REMOVED IN ORDER TO REUSE ELSEWHERE *
 *
 * @author Jeff Maki <jmaki@nerdery.com>
 * @version 1.0
 */

(function (context) {
    'use strict';

    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('views/ContentSliderView',['require','jquery','GlobalEventDispatcher'],function (require) {
        var $ = require('jquery');
        var GlobalEventDispatcher = require('GlobalEventDispatcher');

        /**
         *  This module handles the laying out of a list of content items.  It allows a number of content elements to be visible at once.
         *  it also allows the visible content items to be filtered down base on a parameter.
         *
         *  This module also provides an interface with which it can be updated by outside controllers, both in its position
         *  and its visible content filter can be updated.
         *
         * @class ContentSliderView short description
         * @param {id} String reference
         * @constructor
         *
         */
        var ContentSliderView = function (listId) {
            /**
             * The content list itself, the parent of the individual list items.
             *
             * @type {jQuery|HTMLElement}
             */
            this.$contentList = $(listId);

            /**
             *  The collection of content items stored as a jQuery object.
             *
             * @type {jQuery}
             */
            this.$contentItems = undefined;

            /**
             * The global instance of an event dispatcher, used to subscribe to or publish events of global interest
             *
             * @type {EventDispatcher}
             */
            this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher();

            /**
             * The current offset state, represents how far the list has been animated away from its starting position
             * @type {Number}
             */
            this.currentOffset = 0;

            /**
             * The total range the list can be animated, it is the difference between the parent container width, and
             * the total width of the visible content.
             *
             * @type {Number}
             */
            this.range = 0;

            /**
             * This is used to add a buffer to the total content width to allow the content to be rendered, including
             * shadows and other graphical effects.
             *
             * @type {Number}
             */
            this.visibleBuffer = 85;

            /**
             * Determines if the page is in LRT or RTL mode, which can be used to adjust which margin is animated
             *
             * @type {Boolean}
             */
            this.shouldUseRTL = $('body').hasClass('rtl');

            this.init();
        };

        /**
         * Initializes the UI Component View
         *
         * Initializes the module by setting up the handlers, creating dom references, and then laying out the relevant
         * content in the browser.
         *
         * @method init
         * @returns {ContentSliderView}
         * @private
         */
        ContentSliderView.prototype.init = function () {
            this.isEnabled = false;

            return this.setupHandlers()
                .createChildren()
                .layout()
                .enable();
        };

        ContentSliderView.prototype.isActive = function () {
            var isEnabled = true;

            if (!this.isEnabled) {
                isEnabled = false;
            }

            if (this.getCurrentRange() <= 0) {
                isEnabled = false;
            }

            return isEnabled;
        };

        /**
         * Binds the scope of any handler functions
         * Should only be run on initialization of the view
         *
         * @method setupHandlers
         * @returns {ContentSliderView}
         * @private
         */
        ContentSliderView.prototype.setupHandlers = function () {

            //on window resize, we want to recalculate the layout parameters
            this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.WINDOW_RESIZE, this.resetContentView.bind(this));

            return this;
        };


        /**
         * Create any child objects or references to DOM elements
         * Should only be run on initialization of the view
         *
         * @method createChildren
         * @returns {ContentSliderView}
         * @private
         */
        ContentSliderView.prototype.createChildren = function () {
            this.$contentItems = this.$contentList.children();

            this.setCurrentRange();

            return this;
        };


        /**
         * Performs measurements and applys any positiong style logic
         * Should be run anytime the parent layout changes
         *
         * @method layout
         * @returns {ContentSliderView}
         * @private
         */
        ContentSliderView.prototype.layout = function () {

            return this;
        };

        /**
         * This method returns the current offset whenever it is called.
         *
         *
         * @method getCurrentOffset
         * @returns {currentOffset}
         * @private
         */
        ContentSliderView.prototype.getCurrentOffset = function () {
            return this.currentOffset;
        };

        /**
         * This method sets the current offset when triggered.
         *
         * @method setCurrentOffset
         * @returns {ContentSliderView}
         * @private
         */
        ContentSliderView.prototype.setCurrentOffset = function (int) {
            if (!this.isEnabled) {
                return this;
            }

            this.currentOffset = int;

            return this;
        };

        /**
         * Filters the content list base on a selector, then sets the current range for the slider
         *
         * @method filterBy
         * @returns {ContentSliderView}
         * @private
         */
        ContentSliderView.prototype.filterBy = function (selector) {
            if (!this.isEnabled) {
                return this;
            }

            if (selector === 'all') {
                this.resetContentView(); //reset the view completely
            } else {
                var $selectedContent = this.$contentItems.filter('li[data-filter-type="' + selector + '"]');
                this.$contentItems.addClass('MMM--sliderContent_isHidden');                         // hide non-selected items
                $selectedContent.removeClass('MMM--sliderContent_isHidden');                           // show selected items that might already be hidden
                this.resetPosition();                              // reset the position of the content list
            }

            this.setCurrentRange();                                // calculate the new range of movement

            return this;

        };

        /**
         * Shows all the content, then resets the the offset to the original position.
         *
         * @method resetContentView
         * @returns {ContentSliderView}
         * @private
         */
        ContentSliderView.prototype.resetContentView = function () {
            this.$contentItems.removeClass('MMM--sliderContent_isHidden');
            this.resetPosition();

            return this;
        };


        /**
         * Returns the current range of the view.
         *
         * @method getCurrentRange
         * @returns {ContentSliderView}
         * @private
         */
        ContentSliderView.prototype.getCurrentRange = function () {
            return this.range;
        };


        /**
         * Runs the calculations on the view to determine what the current range of animation should be.
         *
         * @method setCurrentRange
         * @returns {ContentSliderView}
         * @private
         */
        ContentSliderView.prototype.setCurrentRange = function () {
            // the width of the content list, including margins etc.
            var visibleWidth = this.$contentList.outerWidth(true);

            // the list of items on the list that are currently visible
            var $visibleItems =  this.$contentItems.filter(':visible');


            // the list of the actual content item, including margins etc.
            var contentItemWidth = this.$contentItems.outerWidth(true);


            //get the needed width to display all visible content
            var contentWidth = contentItemWidth * $visibleItems.length;

            /**
             * Set the range to the difference between the width of all visible items and the area they ahve to display,
             * adjusted with the visibility buffer defined above.
             */
            this.range = contentWidth - visibleWidth + this.visibleBuffer;

            // publish an event to allow controllers interested in this view to respond to it being updated
            this.eventDispatcher.publish(GlobalEventDispatcher.EVENTS.CONTENT_UPDATED);

            return this;
        };

        /**
         * Updates the current position of the view
         * @method updatePosition
         * @param {Number} int
         * @return {ContentSliderView}
         * @private
         */
        ContentSliderView.prototype.updatePosition = function (int) {
            var animationMargin = 'margin-left';
            if (this.shouldUseRTL) {
                animationMargin = 'margin-right';
            }

            // update the position only if the range is greater than then zero
            if (this.range > 0 && int > 0) {
                this.offset = (int * this.range);
                var offset = this.offset;
                this.$contentList.css(animationMargin, -offset);
            } else {
                this.$contentList.css(animationMargin, 0);
            }

            return this;
        };

        /**
         * resets the position, used after a filter event or when the window is re-sized
         *
         * @method resetPosition
         * @returns {ContentSliderView}
         * @private
         */
        ContentSliderView.prototype.resetPosition = function () {
            this.setCurrentOffset(0);
            this.setCurrentRange();
            this.updatePosition(0);

            return this;
        };

        /**
         * Enables the view
         * Performs any event binding to handlers
         * Exits early if it is already enabled
         *
         * @method enable
         * @returns {ContentSliderView}
         * @public
         */
        ContentSliderView.prototype.enable = function () {
            if (this.isEnabled) {
                return this;
            }

            this.isEnabled = true;

            return this;
        };

        /**
         * Disables the view
         * Tears down any event binding to handlers
         * Exits early if it is already disabled
         *
         * @method disable
         * @returns {ContentSliderView}
         * @public
         */
        ContentSliderView.prototype.disable = function () {
            if (!this.isEnabled) {
                return this;
            }

            this.isEnabled = false;

            return this;
        };

        return ContentSliderView;
    });

}(MMMRequire));

